import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AutenticacionService } from '../servicio/autenticacion.service';
import { MensajeService } from '../servicio/mensaje.service';
import { MenuNode } from '../../_models/menu';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthPermisionGuard implements CanActivate {
  constructor (
    private auth: AutenticacionService,
    private router: Router,
    private msgserv : MensajeService
  ){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      let permiso = false;

      if (this.auth.currentUserValue){

        
        if ( (!this.auth.currentUserValue.menu || this.auth.currentUserValue.menu.length ==0) &&  state.url == 'logout'){
          return true;
        }

        let menubar = this.auth.currentUserValue.menu;
        let actions  = this.auth.currentUserValue.actions;

        if (actions != null){

          //Se valida si el usuario tiene permisos para la accion 
          Object.keys(actions).forEach(key => {
            if(actions[key] == "/"+next.routeConfig.path){
              permiso = true;
              return;
            }
          }); 

        } 
  
        //permisos en el menu
        if (!permiso){
          for(let i =0; i< menubar.length; i ++ ) {
            if(this.validatePermissionRoute(menubar[i], state.url)){
              permiso = true;
              break;
            }
          }
        }

        if (!permiso){
          this.msgserv.ver_mensaje("Usted no posee permisos para esta acción", '', this.msgserv.TIPO_ERROR);
          this.router.navigate([environment.home]);
        }
      }else {

        this.msgserv.ver_mensaje("Debe realizar login para ingresar a esta ruta", '', this.msgserv.TIPO_ERROR);
        this.router.navigate([environment.login]);

      }

      return permiso;
  }

  /**
   * 
   * @param menu : item del menu que se comparara la ruta
   * @param route : ruta que se compara para validar si tiene permiso
   */
  validatePermissionRoute(menu: MenuNode, route: string): boolean{

      if ("/"+menu.ruta == route){
        return true
      }else if( menu.child.length >0 ){
        let havePermission = false;
        for(let i =0; i < menu.child.length; i++){
          if(this.validatePermissionRoute(menu.child[i], route)){
            havePermission = true
            break;
          }
        }
        return havePermission;
      }else{
        return false
      }
  
  }
  
}
